import styled from "styled-components";

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin: 20px 0;
  width: 100%;
`;

const Ellipsis = styled.span`
  display: flex;
  align-items: center;
  padding: 6px 8px;
  font-size: 14px;
`;

const PageButton = styled.button<{ active?: boolean }>`
  border: none;
  background-color: ${({ active }) => (active ? "#E66F00" : "transparent")};
  color: ${({ active }) => (active ? "white" : "#E66F00")};
  cursor: pointer;
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 4px;

  &:disabled {
    cursor: default;
    color: #aaa;
  }
`;

interface renderProps {
  totalPages: number;
  currentPage: number;
  setCurrentPage: (e: any) => void;
}
export const RenderPagination = ({
  totalPages,
  currentPage,
  setCurrentPage,
}: renderProps) => {
  const buttons: (number | string)[] = [];

  if (totalPages <= 3) {
    // 전체 페이지 다 보여주기
    for (let i = 1; i <= totalPages; i++) buttons.push(i);
  } else {
    const left = Math.max(1, currentPage - 1);
    const right = Math.min(totalPages, currentPage + 1);

    if (left > 0) buttons.push(1);

    if (left > 2) buttons.push("left-ellipsis");

    for (let i = left; i <= right; i++) {
      if (i > 1 && i < totalPages) buttons.push(i);
    }

    if (right < totalPages - 1) buttons.push("right-ellipsis");

    if (right < totalPages + 1) buttons.push(totalPages);
  }

  return (
    <PaginationWrapper>
      <PageButton
        onClick={() => setCurrentPage((prev: any) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        이전
      </PageButton>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {buttons.map((btn, idx) =>
          btn === "left-ellipsis" || btn === "right-ellipsis" ? (
            <Ellipsis key={`ellipsis-${idx}`}>...</Ellipsis>
          ) : (
            <PageButton
              key={btn}
              active={btn === currentPage}
              onClick={() => setCurrentPage(Number(btn))}
            >
              {btn}
            </PageButton>
          )
        )}
      </div>

      <PageButton
        onClick={() =>
          setCurrentPage((prev: any) => Math.min(prev + 1, totalPages))
        }
        disabled={currentPage === totalPages}
      >
        다음
      </PageButton>
    </PaginationWrapper>
  );
};
